import { createStore } from "vuex";
import app from "@/app/index";

export const store = createStore({
  modules: app.store,
});
